export const DESTROY_STORE = 'DESTROY_STORE';

export interface DestroyStore {
    type: typeof DESTROY_STORE;
}

export const DestroyStoreAction = (): DestroyStore => ({
    type: DESTROY_STORE
});